import React from "react";
import { Star } from "lucide-react";

const ReviewCard = ({ review, testid }) => {
    return (
        <article
            data-testid={testid || `review-${review.id}`}
            className="bg-[#FFFFF3] border border-[#3D3D24]/15 p-8 md:p-10 flex flex-col h-full relative"
        >
            <div className="font-serif text-6xl text-[#D4A95A] leading-none mb-3 select-none">“</div>
            <div className="flex items-center gap-1 mb-5">
                {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={14} fill="#D4A95A" stroke="#D4A95A" />
                ))}
            </div>
            <p className="font-serif text-lg md:text-xl text-[#3D3D24] leading-snug italic mb-6 flex-grow">
                {review.text}
            </p>
            <div className="border-t border-[#3D3D24]/15 pt-5 flex items-center justify-between">
                <div>
                    <div className="font-label text-xs text-[#3D3D24]">{review.name}</div>
                    <div className="text-[11px] text-[#3D3D24]/55 mt-1">Google · {review.date}</div>
                </div>
            </div>
        </article>
    );
};

export default ReviewCard;
